// extracted by mini-css-extract-plugin
export var Button = "style-module--Button--B7C-N";